
import React, { useState } from 'react';
import ContactsIcon from '@material-ui/icons/LocalShipping';
import Tooltip from '@material-ui/core/Tooltip';
import ContactDataDialog from './ContactDataDialog';

const ContactDataSellerButton = ({ contactDataId }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Only render if contactDataId is filled
  if (!contactDataId) {
    return null;
  }

  return (
    <div>
      <Tooltip title="Dane dostawcy" placement="left-start">
        <ContactsIcon onClick={() => setIsOpen(true)} />
      </Tooltip>
      <ContactDataDialog
        contactDataId={contactDataId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default ContactDataSellerButton;
